import React from "react";
import SocialIcons from "./SocialIcons";

export default function ArtistCard({ artist, socials }) {
  return (
    <div className="rounded-3xl bg-white/5 border border-white/10 backdrop-blur-lg p-6 shadow-2xl hover:-translate-y-1 transition">
      <div className="flex items-center gap-4 mb-4">
        <img
          src={artist.image}
          alt={artist.name}
          className="w-20 h-20 rounded-full object-cover border-2 border-amber-300/70 shadow-lg"
        />
        <div>
          <h3 className="text-xl font-bold text-white">{artist.name}</h3>
          <p className="text-amber-200 text-sm font-semibold">{artist.role}</p>
        </div>
      </div>
      <p className="text-gray-200 text-sm leading-relaxed mb-4">{artist.highlight}</p>
      <div className="grid gap-2 text-gray-200 text-sm">
        {artist.achievements.map((item) => (
          <div
            key={item}
            className="flex items-start gap-2 rounded-xl bg-white/5 px-3 py-2 border border-white/5"
          >
            <span className="h-2 w-2 rounded-full bg-amber-300 mt-1.5" />
            <span>{item}</span>
          </div>
        ))}
      </div>
      {artist.awards && (
        <div className="mt-5">
          <h4 className="text-white font-semibold mb-2">Awards & Honours</h4>
          <div className="flex flex-wrap gap-2">
            {artist.awards.map((award) => (
              <span
                key={award}
                className="text-xs font-semibold text-amber-300 border border-amber-300/40 rounded-full px-3 py-1 bg-amber-300/10"
              >
                {award}
              </span>
            ))}
          </div>
        </div>
      )}
      {socials ? (
        <SocialIcons socials={socials} className="mt-5" />
      ) : null}
    </div>
  );
}
